export interface Props {
  className?: string;
}

export default function EmailLink({ className }: Props) {
  return (
    <a
      href="mailto:&#109;&#97;&#103;&#105;&#99;&#97;&#108;&#116;&#114;&#97;&#105;&#108;&#115;&#97;&#112;&#112;&#64;&#103;&#109;&#97;&#105;&#108;&#46;&#99;&#111;&#109;"
      className={className}
    >
      &#109;&#97;&#103;&#105;&#99;&#97;&#108;&#116;&#114;&#97;&#105;&#108;&#115;&#97;&#112;&#112;&#64;&#103;&#109;&#97;&#105;&#108;&#46;&#99;&#111;&#109;
    </a>
  );
}
